<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <v-form
          ref="OrderReportCsvForm"
          class="mb-4"
        >
          <v-card elevation="0" tile outlined>
            <v-card-text>
              <div>1. 対象の補助項目を選択してください。</div>
              <v-layout row>
                <v-select
                  v-model="searchQuery.qSubClientNames"
                  :items="subClientNames"
                  multiple
                  class="ma-2"
                  style="max-width: 500px"
                  label="対象の補助項目を指定する"
                  return-object
                />
              </v-layout>
              <div>2. 対象の子部門名を選択してください。</div>
              <v-layout row>
                <v-select
                  v-model="searchQuery.qClientNames"
                  :items="this.clientNames"
                  multiple
                  style="max-width: 500px"
                  class="ma-2"
                  label="対象の子部門名を指定する"
                  return-object
                />
              </v-layout>
              <div>3. 検索する校了日の指定をしてください</div>
              <v-layout row>
                <v-select
                  v-model="searchQuery.completionType"
                  :items="selectCompletionType"
                  item-text="name"
                  item-value="value"
                  return-object
                  style="max-width: 300px"
                  class="ma-2"
                  clearable
                  :rules="[completionTypeValidation]"
                  label="検索する校了日の指定"
                  @input="selectType"
                />
              </v-layout>
              <v-divider />
              <div class="mt-3">4. 検索する校了日の範囲を入力してください</div>
              <v-layout row>
                <v-col>
                  <input-date
                    v-model="searchQuery.startDate"
                    :label="'範囲 開始日'"
                  />
                </v-col>
                <v-col>
                  <input-date
                    v-model="searchQuery.endDate"
                    :label="'範囲 終了日'"
                  />
                </v-col>
              </v-layout>
              <v-layout row content>
                <v-btn color="primary" dark tile class="ma-2" @click="downloadCsv">
                  CSVダウンロード
                </v-btn>
                <v-btn color="teal" dark tile class="ma-2" @click="downloadPdf">
                  PDFダウンロード
                </v-btn>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment'
import InputDate from './InputDate'
import axios from 'axios'
import headUtilsMixin from '@/mixins/head_utils'
import { deserialize } from 'deserialize-json-api'
import Qs from 'qs'
import blobDownloader from '@/mixins/blob_downloader'

export default {
  name: 'OrderReports',
  components: { InputDate },
  mixins: [headUtilsMixin, blobDownloader],
  data () {
    return {
      clientNames: [],
      subClientNames: [],
      pageTitle: 'レポート',
      selectCompletionType: [
        { name: 'ライター校了日', value: 0, key: 'writer' },
        { name: 'クライアント校了日', value: 1, key: 'client' }
      ],
      searchQuery: {
        qClientNames: null,
        qSubClientName: null,
        completionType: null,
        startDate: null,
        endDate: moment().toDate()
      },
      completionTypeValidation: (value) => {
        if (
          (!value || typeof value !== 'object') &&
          typeof value !== 'number'
        ) {
          return '必須入力項目です'
        } else {
          return true
        }
      }
    }
  },
  mounted: function () {
    axios.get(`/api/master/sites`).then((data) => {
      const sites = deserialize(data.data).data
      const clientNameArray = []
      const subClientNameArray = []
      Object.keys(sites).forEach(function (key) {
        if (sites[key].clientName != null) {
          clientNameArray.push(sites[key].clientName)
        }
        if (sites[key].subClientName != null) {
          subClientNameArray.push(sites[key].subClientName)
        }
      })
      this.clientNames = [...new Set(clientNameArray)]
      this.subClientNames = [...new Set(subClientNameArray)]
    })
  },
  methods: {
    downloadCsv () {
      if (!this.$refs.OrderReportCsvForm.validate()) return false
      axios
        .get('/api/master/orders/reports.csv', {
          responseType: 'blob',
          params: { file_type: 'ja', q: this.searchQuery },
          paramsSerializer: function (params) {
            return Qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        .then((response) => {
          this.downloadBlob(response)
        })
        .catch((error) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          const payload = {
            status: error.response.status,
            message: 'CSVファイルの作成に失敗しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        })
    },
    downloadPdf () {
      if (!this.$refs.OrderReportCsvForm.validate()) return false
      axios
        .get('/api/master/orders/reports.pdf', {
          params: this.searchQuery,
          responseType: 'application/pdf'
        })
        .then((response) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          const binaryString = atob(response.data)
          const len = binaryString.length
          const buffer = new ArrayBuffer(len)
          const view = new Uint8Array(buffer)
          for (let i = 0; i < len; i += 1) {
            view[i] = binaryString.charCodeAt(i)
          }
          const blob = new Blob([view], { type: 'application/pdf' })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `${this.fileName()}.pdf`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
          link.parentNode.removeChild(link)
        })
        .catch((error) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          const payload = {
            status: error.response.status,
            message: 'PDFファイルの作成に失敗しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        })
    },
    fileName () {
      const today = moment().format('YYYYMMDD')
      const rangeStart = moment(this.searchQuery.startDate).format('YYYYMMDD')
      const rangeEnd = moment(this.searchQuery.endDate).format('YYYYMMDD')
      const completionTypeKey = this.selectCompletionType.find(
        (item) => item.value === this.searchQuery.completionType
      ).key
      return `${today}_${completionTypeKey}_${rangeStart}-${rangeEnd}`
    },
    selectType (event) {
      if (typeof event.value !== 'number') return

      this.searchQuery.completionType = event.value
    }
  }
}
</script>

<style lang="sass" scoped>
.vdp-datepicker
  margin: auto 0 auto 5px
.vdp-datepicker input
  border-radius: 5px
  padding: 7px 10px
  border: 1px solid #707070
  width: 300px
</style>
